var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.688,
    height: 18.692,
    viewBox: "0 0 18.688 18.692",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_x32_-Magnifying_Glass",
    transform: "translate(-7.129 -7.125)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M25.493,23.927,21.9,20.334A8.251,8.251,0,1,0,20.334,21.9l3.592,3.592a1.108,1.108,0,1,0,1.566-1.566ZM11.1,19.609a6.015,6.015,0,1,1,4.253,1.762A6.023,6.023,0,0,1,11.1,19.609Z",
    transform: "translate(0)",
    fill: "#d4d4d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search_.423de5a9d694dfd9a968703c024cb6a5.svg";
export { ForwardRef as ReactComponent };